import { AppIconsSearch, ApplicationSearchType } from 'interfaces/api_deep_search.interfaces';
import React, { useEffect, useRef, useState } from 'react';
import { CommonDocumentService } from '@umanforge/common';
import { Tooltip } from 'react-tooltip';

interface BaseCardProps {
  id: string;
  application: ApplicationSearchType;
  title: string;
  breadcrumb: string;
  firstChildren?: JSX.Element;
  secondeChildren?: JSX.Element;
  sizeBytes?: number;
}

const BaseCardComponent: React.FC<BaseCardProps> = ( { id, title, application, breadcrumb, firstChildren, secondeChildren, sizeBytes } ) => {
  const Icon = AppIconsSearch[ application ];
  const breadcrumbRef = useRef<HTMLSpanElement>( null );

  const [ isBreadcrumbClamped, setIsBreadcrumbClamped ] = useState( false );

  useEffect( () => {
    window.addEventListener( 'resize', updateTooltipVisibility );

    return () => {
      window.removeEventListener( 'resize', updateTooltipVisibility );
    };
  }, [] );

  useEffect( () => {
    updateTooltipVisibility();
  }, [ breadcrumbRef ] );

  const updateTooltipVisibility = () => {
    let result = false;
    const currentBreadcrumbRef = breadcrumbRef.current;
    if ( currentBreadcrumbRef ) {
      result = currentBreadcrumbRef.scrollHeight > currentBreadcrumbRef.clientHeight;
    }
    setIsBreadcrumbClamped( result );
  };

  return (
    <div className='flex flex-col grow min-w-[340px] w-[30%] h-fit rounded-xl border border-gray-200'>
      <div className='flex min-h-[130px] h-full'>
        <div
          className={ `flex flex-col w-full ${ secondeChildren != undefined ? 'py-2 pl-2' : 'p-2'  } gap-2`}
          style={{ containerType: 'inline-size' }}
        >
          <div className='flex w-full gap-2 items-center'>
            <Icon className='h-7 w-7'/>
            <h4 className='font-semibold text-gray-900 text-lg truncate'>
              { title }
            </h4>
          </div>
          <div className='h-full'>
            {
              firstChildren != undefined ?
                firstChildren
                :
                null
            }
          </div>
        </div>
        <div>
          {
            secondeChildren != undefined ?
              secondeChildren
              :
              null
          }
        </div>
      </div>
      <hr/>
      <span
        className='h-fit mx-2 my-0.5 text-[10px] text-gray-600 line-clamp-1'
        id={ `tooltip-breadcrumb-${ id }` }
        ref={ breadcrumbRef }
      >
        { breadcrumb }
      </span>
      {
        typeof sizeBytes === 'number' && (
          <span className='mx-2 my-0.5 text-[10px] text-gray-500'>
            { CommonDocumentService.getReadableFileSizeString( sizeBytes ) }
          </span>
        )
      }
      {
        isBreadcrumbClamped ?
          <Tooltip anchorSelect={ `#tooltip-breadcrumb-${ id }` } place='bottom'>
            <span className='text-xs'>
              { breadcrumb }
            </span>
          </Tooltip>
          :
          null
      }
    </div>
  );
};

export { BaseCardComponent };
